// Define known staging domains
const stagingDomains = ["staging-dashboard.iotventure.cloud"]

// Determine the current environment based on the hostname:
// 1. localhost / 127.0.0.1 → "local" (development)
// 2. Known staging domain → "staging"
// 3. Everything else (including all partner domains) → "production"
export const env: "production" | "staging" | "local" =
  window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"
    ? "local"
    : stagingDomains.includes(window.location.hostname)
      ? "staging"
      : "production"

// export const env: "production" | "staging" =
//   window.location.hostname == "dashboard.iot-venture.com" ? "production" : "staging"

export const GOOGLE_MAPS_API_KEY = "AIzaSyA9fBm6M76PHrHao4Q64vSevP1RZpWIc0M"

export const SENTRY_DSN =
  "https://cfac4fa025204e6bbde7bdd539cef32d@o100561.ingest.sentry.io/6698472"
